import * as React from 'react';
export const convertSvg = React.forwardRef(function convertSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.26 8.2a.75.75 0 1 0-1.02 1.1l2.1 1.95H1.75a.75.75 0 0 0 0 1.5h10.59l-2.1 1.95a.75.75 0 1 0 1.02 1.1l3.5-3.25a.75.75 0 0 0 0-1.1l-3.5-3.25Zm-5.5-6.9A.75.75 0 0 0 4.74.2L1.242 3.448a.748.748 0 0 0-.001 1.103L4.74 7.8a.75.75 0 0 0 1.02-1.1l-2.1-1.95h10.59a.75.75 0 0 0 0-1.5H3.66l2.1-1.95Z',
    }),
  );
});
convertSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var convert = {
  category: 'icon',
  colorable: true,
  name: 'convert',
  svg: convertSvg,
};
